import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { LayoutUtilsService } from '@app/core/_base/crud';
import { MatDialog } from '@angular/material';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { HotDealService, ProductService } from '@app/api/api';
import { environment } from 'environments/environment';
import { debounceTime, map } from 'rxjs/operators';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { HotDeal } from '@app/model/hotDeal';
import * as _moment from 'moment';

const moment = _moment;

const IN_DB = 1;
const NOT_IN_DB = 0;

@Component({
  selector: 'meu-deals-management',
  templateUrl: './deals-management.component.html',
  styleUrls: ['./deals-management.component.scss'],
})
export class AppDealsManagementComponent implements OnInit {
  host: any;
  total: any;
  isChanged = false;

  displayedColumns: string[] = ['index', 'name', 'from', 'to', 'price', 'actions'];
  lstAllDeal: any = [];
  dataSource = new MatTableDataSource(this.lstAllDeal);
  lstDealDelete: any = [];

  //Select product
  public keyUpLogo = new Subject<KeyboardEvent>();
  filterProductInput: string = '';
  filterProduct: string = '';
  totalProduct: number;
  selectProductID: string;
  lstProduct = [];
  pageLoad: number = 1;
  productShow: number = 10;

  constructor(
    private layoutUtilsService: LayoutUtilsService,
    public dialog: MatDialog,
    private toastr: ToastrService,
    private ref: ChangeDetectorRef,
    private productService: ProductService,
    private hotdealService: HotDealService
  ) {}
  ngOnInit() {
    this.keyUpLogo
      .pipe(
        map((event) => event),
        debounceTime(300)
      )
      .subscribe((value) => {
        this.filterProduct = 'name@=*' + value;
        this.pageLoad = 1;
        this.lstProduct = [];
        this.getAllProduct();
      });

    this.getAllProduct();
    this.getAllDeal();
  }
  //Sort list deal trong table
  sortDeals() {
    this.lstAllDeal.sort((a, b) => {
      return a.sort_order - b.sort_order;
    });
    for (let i = 0; i < this.lstAllDeal.length; i++) {
      this.lstAllDeal[i].sort_order = i + 1;
    }
  }
  //Đổi vị trí 2 logo
  upDeal(id: string) {
    var index = this.lstAllDeal.findIndex((p) => p.productId === id);
    this.isChanged = true;
    if (index > 0) {
      this.swapDeal(index, index - 1); //index-1 phần tử nằm phía trước
      this.dataSource.data = this.lstAllDeal;
    }
  }
  downDeal(id: string) {
    this.isChanged = true;
    var index = this.lstAllDeal.findIndex((p) => p.productId === id);
    if (index < this.lstAllDeal.length - 1) {
      this.swapDeal(index, index + 1); //index+1 phần tử nằm phía sau
      this.dataSource.data = this.lstAllDeal;
    }
  }
  swapDeal(index1: number, index2: number) {
    var temp = this.lstAllDeal[index1].sort_order;
    this.lstAllDeal[index1].sort_order = this.lstAllDeal[index2].sort_order;
    this.lstAllDeal[index2].sort_order = temp;
    this.sortDeals();
  }

  //Button click
  deleteDeal(id: string) {
    this.isChanged = true;
    let index = this.lstAllDeal.findIndex((p) => p.productId == id);
    const title = 'Xóa logo';
    const description = 'Bạn có chắc chắn muốn xóa logo này?';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.deleteElement(title, description, waitDesciption);
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        if (this.lstAllDeal[index].status == IN_DB) {
          this.lstDealDelete.push(this.lstAllDeal[index]);
        }

        this.lstAllDeal.splice(index, 1);
        this.sortDeals();
        this.dataSource.data = this.lstAllDeal;
        this.ref.detectChanges();
        // this.toastr.success('Xóa thành công');
      }
    });
  }
  saveChangeDeal() {
    this.isChanged = false;
    this.updateChangeToDb();
    this.lstDealDelete = [];
    this.ref.detectChanges();
  }
  cancelChange() {
    const action = 'Xác nhận';
    const title = 'Hủy thao tác';
    const description = 'Các thay đổi bạn đã thực hiện sẽ không được lưu.';
    const waitDesciption = 'Đang xử lý...';
    const dialogRef = this.layoutUtilsService.updateElement(
      action,
      'warn',
      title,
      description,
      waitDesciption
    );
    dialogRef.afterClosed().subscribe((res) => {
      if (!res) {
        return;
      } else {
        this.getAllDeal();
        this.isChanged = false;
        this.toastr.success('Hủy thao tác thành công');
      }
    });
  }
  //---end
  updateChangeToDb() {
    var countUnsuccess = 0;
    for (let i = 0; i < this.lstAllDeal.length; i++) {
      var deal = this.lstAllDeal[i];
      var data;
      switch (deal.status) {
        case IN_DB:
          data = {
            sort_order: deal.sort_order,
          } as HotDeal;
          this.hotdealService.apiHotDealsIdPut(deal.id, data).subscribe((res) => {
            if (!res.success) {
              countUnsuccess++;
              this.toastr.error(res.message);
            }
          });
          break;
        case NOT_IN_DB:
          var dataNew = {
            product_id: deal.productId,
            sort_order: deal.sort_order,
          } as HotDeal;
          this.hotdealService.apiHotDealsPost(dataNew).subscribe((res) => {
            if (!res.success) {
              countUnsuccess++;
              this.toastr.error(res.message);
            } else {
              this.lstAllDeal[i].status = IN_DB;
              this.lstAllDeal[i].id = res && res.data ? res.data.id : null;
            }
          });
          break;
      }
    }
    this.deleteDealFromDb();
    if (countUnsuccess == 0) {
      this.toastr.success('Lưu thành công!');
    }
  }
  addDealToTable() {
    if (this.selectProductID == '' || this.selectProductID == null) {
      return;
    }
    var selectedProduct = this.lstProduct.find((p) => p.id == this.selectProductID);
    let indexDeal = this.lstAllDeal.findIndex((p) => p.productId == this.selectProductID);
    if (indexDeal != -1) {
      const description = 'Sản phẩm bạn chọn đã được thêm';
      this.toastr.warning(description, 'Thêm thất bại');
    } else {
      var sort = 0;
      if (this.lstAllDeal.length != 0) {
        sort = this.lstAllDeal[this.lstAllDeal.length - 1].sort_order;
      }
      var data = {
        sort_order: sort + 1,
        productId: selectedProduct.id,
        logo: selectedProduct.logo,
        sku: selectedProduct.sku,
        name: selectedProduct.name,
        to: selectedProduct.promotion_deadline,
        from: selectedProduct.promotion_from,
        price: selectedProduct.price,
        status: NOT_IN_DB,
      };
      this.isChanged = true;
      this.lstAllDeal.push(data);
      let index = this.lstProduct.findIndex((p) => p.id == this.selectProductID);
      this.lstProduct.splice(index, 1);
      this.dataSource.data = this.lstAllDeal;
      this.selectProductID = '';
    }
  }

  //api delete
  deleteDealFromDb() {
    for (let i = 0; i < this.lstDealDelete.length; i++) {
      this.hotdealService.apiHotDealsIdDelete(this.lstDealDelete[i].id).subscribe((res) => {
        if (!res.success) {
          this.toastr.error(res.message);
        }
      });
    }
    this.lstDealDelete = [];
  }
  //Data cho table
  getAllDeal() {
    this.lstAllDeal = [];
    this.hotdealService.apiHotDealsGet().subscribe((res) => {
      if (res.success) {
        for (let i = 0; i < res.data.collection.length; i++) {
          var data = {
            id: res.data.collection[i].id,
            sort_order: res.data.collection[i].sort_order,
            productId: res.data.collection[i].product_id,
            name: res.data.collection[i].extend_product.name,
            to: res.data.collection[i].extend_product.promotion_deadline,
            from: res.data.collection[i].extend_product.promotion_from,
            price: res.data.collection[i].extend_product.price,
            logo: res.data.collection[i].extend_product.default_image,
            sku: res.data.collection[i].extend_product.sku,
            status: IN_DB,
          };
          this.lstAllDeal.push(data);
        }
        this.sortDeals();
        this.dataSource.data = this.lstAllDeal;

        this.total = res.data.total;
        this.host = environment.backendhost;
        this.ref.detectChanges();
      }
    });
  }

  //Data cho select
  getAllProduct() {
    this.productService
      .apiProductsGet(this.filterProduct, '', this.pageLoad, 10)
      .subscribe((res) => {
        if (res.success) {
          for (let i = 0; i < res.data.collection.length; i++) {
            let index = this.lstProduct.findIndex((p) => p.id == res.data.collection[i].id);
            if (index == -1) {
              this.lstProduct.push({
                id: res.data.collection[i].id,
                logo: res.data.collection[i].default_image,
                sku: res.data.collection[i].sku,
                name: res.data.collection[i].name,
                promotion_from: res.data.collection[i].promotion_from,
                promotion_deadline: res.data.collection[i].promotion_deadline,
                price: res.data.collection[i].price,
              });
            }
          }
          //lay do dai thuc
          this.pageLoad = res.data.pageIndex;
          this.productShow = 10 * this.pageLoad;
          this.totalProduct = res.data.total;
        }
        this.ref.detectChanges();
      });
  }
  isInHotDealTable(productId: string) {
    return this.lstAllDeal.findIndex((p) => p.productId == productId) == -1 ? false : true;
  }
  loadMore() {
    this.pageLoad += 1;
    this.selectProductID = '';
    this.getAllProduct();
  }
  moment(date) {
    return moment(date).format('DD-MM-YYYY - hh:mm');
  }
  search() {
    if (this.selectProductID != '' && this.selectProductID != null) {
      var selectedProduct;
      this.filterProduct = 'name@=*';
      this.pageLoad = 1;

      selectedProduct = this.lstProduct.find((p) => p.id == this.selectProductID);

      this.lstProduct = [];
      this.lstProduct.push(selectedProduct);
      this.getAllProduct();
    }
  }
}
